<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      <ion-button (click)="modalController.dismiss()">
        {{ 'core.done' | translate }}
      </ion-button>
    </ion-buttons>

    <ion-title>{{ 'settings.accessibility.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>


<ion-content class="ion-padding">
  <h2>{{ 'settings.accessibility.title' | translate }}</h2>
  <p>
    Die TU Dortmund hat den Anspruch, ihre mobilen Anwendungen und Webseiten
    entsprechend der EU-Richtlinie 2016/2102 barrierefrei zugänglich zu machen.
    Die folgende Erklärung zur Barrierefreiheit dokumentiert den Umsetzungsstand
    für den Webauftritt WebApps gemäß der Verordnung zur Schaffung
    barrierefreier Informationstechnik nach dem Behindertengleichstellungsgesetz
    Nordrhein-Westfalen.
  </p>


  <p>
    Stand der Vereinbarkeit mit den Anforderungen diese App ist mit der EU-Richtlinie 2016/2102 teilweise konform.
    
    Methodik der Prüfung: Selbstbewertung
    Erstellt am: 21.06.2021
    Zuletzt geprüft am: 21.06.2021
  </p>

  <h2>
    Nicht barrierefreie Inhalte
  </h2>

  <p>
    Die nachstehend aufgeführten Inhalte sind nicht barrierefrei:
  </p>
  
  <ul>
    <li>
      Die Darstellung der Karte in der Navigation kann nicht vorgelesen
      werden.
      <ul>
        <li>
          <strong>Begründung:</strong> Eine Turn-by-Turn-Navigation für Fußgänger auf dem Campus wäre
  vorlesbar, kann aber aufgrund der Datenlage nicht umgesetzt werden. Die
  Anweisungen sind nicht präzise genug.
        </li>
        <li>
          <strong>Barrierefreie Alternativen:</strong> Bitte verwenden Sie ihre Navigationsapp, in die Sie schon gut
      eingearbeitet sind.
        </li>
      </ul>
    </li>
  </ul>
  
  <p>
  </p>

  <h2>Feedback und Kontaktangaben</h2>
  <p>
    Sie können uns Mängel bei der Einhaltung der Anforderungen an die
    Barrierefreiheit mitteilen und Informationen zu Inhalten anfordern, die von
    der Richtlinie ausgenommen sind.
  </p>

  <h3>
    Kontakt
  </h3>
  <p>
    <a href="/employee-search/DE1130000005308">Arne v.Irmer (7127)</a>
  </p>

  <h3>
    Feedback
  </h3>

  <p>
    Wenn Sie Kontakt zum ITMC aufnehmen möchten, nutzen Sie bitte die
    E-Mail-Adresse des Service-Desk unter <a href="mailto:service.itmc@tu-dortmund.de">service.itmc&#64;tu-dortmund.de</a>
    Bitte geben Sie bei der Nachricht das Stichwort Barrierefreiheit an und
    teilen uns unter Nennung der URL mit, auf welchen Inhalt Sie sich beziehen.
  </p>
</ion-content>

